module.exports = __webpack_public_path__ + "static/media/lesson_chapter_3.6da0db27.png";